import { render } from "./Strategy.vue?vue&type=template&id=8f5120bc&scoped=true"
import script from "./Strategy.vue?vue&type=script&lang=js"
export * from "./Strategy.vue?vue&type=script&lang=js"

import "./Strategy.vue?vue&type=style&index=0&id=8f5120bc&scoped=true&lang=css"
import "./Strategy.vue?vue&type=style&index=1&id=8f5120bc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f5120bc"]])

export default __exports__